import React from "react";
import "../styles/FeedbackStyles.css";

export interface FeedbackItem {
  candidate_id: string;
  role_name: string;
  institute_name?: string;
  program_id?: string;
  course_id?: string;
  topic_id?: string;
  video_id?: string;
  video_name?: string;
  module_name?: string;
  module_score?: string;
  event_name?: string;
  feedback_message: string;
  feedback_posted_time: string;
  feedback_id: string;
  creator_name?: string;
  instructor_name?: string;
  created_by?: string;
  program_category?: string;
  is_lab_session?: boolean;
  program_title?: string;
}

// export const renderFeedbackMessage = (
//   message: string,
//   feedbackData?: FeedbackItem,
// ): React.ReactNode => {
//   if (!message) return null;

//   // Split by newlines to preserve line breaks
//   const lines = message.split("\n");

//   // Combine all lines into a single message with proper spacing
//   const combinedMessage = lines.join(" ");

//   // Find all matches in the combined message
//   const patterns: { regex: RegExp; className: string; type: string }[] = [];

//   // Module pattern - MUST come first to be more specific
//   if (feedbackData?.module_name) {
//     const escapedName = feedbackData.module_name.replace(
//       /[-\/\\^$*+?.()|[\]{}]/g,
//       "\\$&",
//     );
//     const score = feedbackData.module_score || "\\d+";
//     patterns.push({
//       regex: new RegExp(`\\+\\s*${escapedName}\\s*${score}%?`, "g"),
//       className: "common-feedback-module",
//       type: "module",
//     });
//   } else {
//     patterns.push({
//       regex: /\+(.*?)\s+(\d+)%/g,
//       className: "common-feedback-module",
//       type: "module",
//     });
//   }

//   // Report pattern - must come before resource
//   patterns.push({
//     regex:
//       /\*\s*(Overall Progress|Completion Steps)(?:\s+(\d+(?:\/\d+)?%?))?/gi,
//     className: "common-feedback-report",
//     type: "report",
//   });

//   // Resource pattern - only match if it's not already part of module or report
//   if (feedbackData?.video_name) {
//     const escapedName = feedbackData.video_name.replace(
//       /[-\/\\^$*+?.()|[\]{}]/g,
//       "\\$&",
//     );
//     patterns.push({
//       regex: new RegExp(`\\/\\s*${escapedName}`, "g"),
//       className: "common-feedback-resource",
//       type: "resource",
//     });
//   } else {
//     patterns.push({
//       regex: /\/\s+([^#+*!\n]+?)(?=\s+[+#*!]|\s+[a-z]|\s*$)/g,
//       className: "common-feedback-resource",
//       type: "resource",
//     });
//   }

//   // Event pattern
//   if (feedbackData?.event_name) {
//     const escapedName = feedbackData.event_name.replace(
//       /[-\/\\^$*+?.()|[\]{}]/g,
//       "\\$&",
//     );
//     patterns.push({
//       regex: new RegExp(`#\\s*${escapedName}`, "g"),
//       className: "common-feedback-event",
//       type: "event",
//     });
//   } else {
//     patterns.push({
//       regex: /#([^#+*!/\s][^#+*!]*?)(?=\s+[+#*!]|\s*$)/g,
//       className: "common-feedback-event",
//       type: "event",
//     });
//   }

//   // Attention/Kudos pattern - MUST come last
//   patterns.push({
//     regex: /!\s+((?:[⚠☆★]\s+)?(?:Attention|attention|Kudos|kudos))/g,
//     className: "common-feedback-attention",
//     type: "attention",
//   });

//   const matches: {
//     start: number;
//     end: number;
//     text: string;
//     className: string;
//     type: string;
//   }[] = [];

//   patterns.forEach(({ regex, className, type }) => {
//     let match: RegExpExecArray | null;
//     const regexCopy = new RegExp(regex.source, "g");
//     while ((match = regexCopy.exec(combinedMessage)) !== null) {
//       const fullMatch = match[0];
//       const start = match.index;
//       const end = start + fullMatch.length;

//       // Check if this match overlaps with any existing match
//       const overlaps = matches.some(
//         (existing) =>
//           (start >= existing.start && start < existing.end) ||
//           (end > existing.start && end <= existing.end),
//       );

//       // Skip if overlapping with a more specific match (module or report)
//       if (overlaps) {
//         continue;
//       }

//       // For attention, check if it's kudos
//       let finalClassName = className;
//       let finalType = type;
//       if (type === "attention") {
//         const label = match[1];
//         if (
//           label &&
//           (label.includes("☆") ||
//             label.includes("Kudos") ||
//             label.includes("kudos") ||
//             label.includes("★"))
//         ) {
//           finalClassName = "common-feedback-kudos";
//           finalType = "kudos";
//         }
//       }

//       matches.push({
//         start,
//         end,
//         text: fullMatch,
//         className: finalClassName,
//         type: finalType,
//       });
//     }
//   });

//   // Sort matches by start position
//   matches.sort((a, b) => a.start - b.start);

//   // Build the JSX for this line
//   const parts: React.ReactNode[] = [];
//   let lastIndex = 0;

//   matches.forEach((match, index) => {
//     // Add text before the match
//     if (match.start > lastIndex) {
//       parts.push(
//         <span key={`text-${index}-before`}>
//           {combinedMessage.substring(lastIndex, match.start)}
//         </span>,
//       );
//     }

//     // Custom chip formatting based on type
//     if (match.type === "module") {
//       const cleaned = match.text.replace(/^\+\s*/, "").trim();
//       const pctMatch = cleaned.match(/(.*?)\s+(\d+)\s*%?$/);
//       if (pctMatch) {
//         const moduleName = pctMatch[1].trim();
//         const percentage = pctMatch[2] + "%";
//         parts.push(
//           <span
//             key={`chip-${index}`}
//             className="module-pill-single"
//           >
//             <span>{moduleName}</span>
//             <span className="module-score">
//               {percentage}
//             </span>
//           </span>,
//         );
//       } else {
//         parts.push(
//           <span key={`chip-${index}`} className="module-pill-single">
//             {cleaned}
//           </span>,
//         );
//       }
//     } else if (match.type === "report") {
//       const cleaned = match.text.replace(/^\*\s*/, "").trim();
//       const valMatch = cleaned.match(
//         /(Overall Progress|Completion Steps)\s+(\d+(?:\/\d+)?%?)$/i,
//       );
//       if (valMatch) {
//         const reportName = valMatch[1].trim();
//         const value = valMatch[2].trim();
//         parts.push(
//           <span
//             key={`chip-${index}`}
//             className="report-pill-single"
//           >
//             <span>{reportName}</span>
//             <span className="report-score">
//               {value}
//             </span>
//           </span>,
//         );
//       } else {
//         parts.push(
//           <span
//             key={`chip-${index}`}
//             className="common-feedback-inline-chip common-feedback-report"
//           >
//             {cleaned}
//           </span>,
//         );
//       }
//     } else if (match.type === "attention") {
//       const cleaned = match.text
//         .replace(/^!\s*/, "")
//         .replace(/^[⚠☆★]\s*/, "")
//         .trim();
//       parts.push(
//         <span key={`chip-${index}`} className="feedback-pill attention-pill">
//           <span className="v2-dashboard-feedback-pill-icon">⚠</span>
//           <span className="v2-dashboard-feedback-pill-text">{cleaned}</span>
//         </span>,
//       );
//     } else if (match.type === "kudos") {
//       const cleaned = match.text
//         .replace(/^!\s*/, "")
//         .replace(/^[⚠☆★]\s*/, "")
//         .trim();
//       parts.push(
//         <span key={`chip-${index}`} className="feedback-pill kudos-pill">
//           <span className="v2-dashboard-feedback-pill-icon">☆</span>
//           <span className="v2-dashboard-feedback-pill-text">{cleaned}</span>
//         </span>,
//       );
//     } else if (match.type === "resource") {
//       let cleaned = match.text.replace(/^\/\s*/, "").trim();
//       if (!cleaned.toLowerCase().startsWith("video:")) {
//         cleaned = "Video: " + cleaned;
//       }
//       parts.push(
//         <span key={`chip-${index}`} className="feedback-pill resource-pill">
//           <span className="v2-dashboard-feedback-pill-text">{cleaned}</span>
//         </span>,
//       );
//     } else if (match.type === "event") {
//       const cleaned = match.text.replace(/^#\s*/, "").trim();
//       parts.push(
//         <span key={`chip-${index}`} className="feedback-pill event-pill">
//           <span className="v2-dashboard-feedback-pill-text">{cleaned}</span>
//         </span>,
//       );
//     } else {
//       parts.push(
//         <span
//           key={`chip-${index}`}
//           className={`common-feedback-inline-chip ${match.className}`}
//         >
//           {match.text}
//         </span>,
//       );
//     }

//     lastIndex = match.end;
//   });

//   // Add remaining text
//   if (lastIndex < combinedMessage.length) {
//     parts.push(
//       <span key={`text-end`}>{combinedMessage.substring(lastIndex)}</span>,
//     );
//   }

//   // If no matches found, just return the message as text
//   if (matches.length === 0) {
//     return (
//       <div className="common-feedback-message-line">
//         {combinedMessage || "\u00A0"}
//       </div>
//     );
//   }

//   return <div className="common-feedback-message-line">{parts}</div>;
// };

export const renderFeedbackMessage = (
  message: string,
  feedbackData?: FeedbackItem,
  onResourceClick?: (feedback: FeedbackItem) => void,
): React.ReactNode => {
  if (!message) return null;

  // Split by newlines to preserve line breaks
  const lines = message.split("\n");

  // Combine all lines into a single message with proper spacing
  const combinedMessage = lines.join(" ");

  // Find all matches in the combined message
  const patterns: { regex: RegExp; className: string; type: string }[] = [];

  // Module pattern - MUST come first to be more specific
  if (feedbackData?.module_name) {
    const escapedName = feedbackData.module_name.replace(
      /[-\/\\^$*+?.()|[\]{}]/g,
      "\\$&",
    );
    const score = feedbackData.module_score || "\\d+";
    patterns.push({
      regex: new RegExp(`\\+\\s*${escapedName}\\s*${score}%?`, "g"),
      className: "common-feedback-module",
      type: "module",
    });
  } else {
    patterns.push({
      regex: /\+(.*?)\s+(\d+)%/g,
      className: "common-feedback-module",
      type: "module",
    });
  }

  // Report pattern - must come before resource
  patterns.push({
    regex:
      /\*\s*(Overall Progress|Completion Steps)(?:\s+([\d.]+(?:\/\d+)?%?))?/gi,

    className: "common-feedback-report",
    type: "report",
  });

  // Resource pattern - only match if it's not already part of module or report
  if (feedbackData?.video_name) {
    const escapedName = feedbackData.video_name.replace(
      /[-\/\\^$*+?.()|[\]{}]/g,
      "\\$&",
    );
    patterns.push({
      regex: new RegExp(`\\/\\s*${escapedName}`, "g"),
      className: "common-feedback-resource",
      type: "resource",
    });
  } else {
    patterns.push({
      regex: /\/\s+([^#+*!\n]+?)(?=\s+[+#*!]|\s+[a-z]|\s*$)/g,
      className: "common-feedback-resource",
      type: "resource",
    });
  }

  // Event pattern
  if (feedbackData?.event_name) {
    const escapedName = feedbackData.event_name.replace(
      /[-\/\\^$*+?.()|[\]{}]/g,
      "\\$&",
    );
    patterns.push({
      regex: new RegExp(`#\\s*${escapedName}`, "g"),
      className: "common-feedback-event",
      type: "event",
    });
  } else {
    patterns.push({
      regex: /#([^#+*!/\s][^#+*!]*?)(?=\s+[+#*!]|\s*$)/g,
      className: "common-feedback-event",
      type: "event",
    });
  }

  // Attention/Kudos pattern - MUST come last
  patterns.push({
    regex: /!\s+((?:[⚠☆★]\s+)?(?:Attention|attention|Kudos|kudos))/g,
    className: "common-feedback-attention",
    type: "attention",
  });

  const matches: {
    start: number;
    end: number;
    text: string;
    className: string;
    type: string;
  }[] = [];

  patterns.forEach(({ regex, className, type }) => {
    let match: RegExpExecArray | null;
    const regexCopy = new RegExp(regex.source, "g");
    while ((match = regexCopy.exec(combinedMessage)) !== null) {
      const fullMatch = match[0];
      const start = match.index;
      const end = start + fullMatch.length;

      // Check if this match overlaps with any existing match
      const overlaps = matches.some(
        (existing) =>
          (start >= existing.start && start < existing.end) ||
          (end > existing.start && end <= existing.end),
      );

      // Skip if overlapping with a more specific match (module or report)
      if (overlaps) {
        continue;
      }

      // For attention, check if it's kudos
      let finalClassName = className;
      let finalType = type;
      if (type === "attention") {
        const label = match[1];
        if (
          label &&
          (label.includes("☆") ||
            label.includes("Kudos") ||
            label.includes("kudos") ||
            label.includes("★"))
        ) {
          finalClassName = "common-feedback-kudos";
          finalType = "kudos";
        }
      }

      matches.push({
        start,
        end,
        text: fullMatch,
        className: finalClassName,
        type: finalType,
      });
    }
  });

  // Sort matches by start position
  matches.sort((a, b) => a.start - b.start);

  // Build the JSX for this line
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  matches.forEach((match, index) => {
    // Add text before the match
    if (match.start > lastIndex) {
      parts.push(
        <span key={`text-${index}-before`}>
          {combinedMessage.substring(lastIndex, match.start)}
        </span>,
      );
    }

    // Custom chip formatting based on type
    if (match.type === "module") {
      const cleaned = match.text.replace(/^\+\s*/, "").trim();
      const pctMatch = cleaned.match(/(.*?)\s+(\d+)\s*%?$/);
      if (pctMatch) {
        const moduleName = pctMatch[1].trim();
        const percentage = pctMatch[2] + "%";
        parts.push(
          <span key={`chip-${index}`} className="module-pill-single">
            <span>{moduleName}</span>
            <span className="module-score">{percentage}</span>
          </span>,
        );
      } else {
        parts.push(
          <span key={`chip-${index}`} className="module-pill-single">
            {cleaned}
          </span>,
        );
      }
    } else if (match.type === "report") {
      const cleaned = match.text.replace(/^\*\s*/, "").trim();
      const valMatch = cleaned.match(
        /(Overall Progress|Completion Steps)\s+([\d.]+(?:\/\d+)?%?)$/i,
      );
      if (valMatch) {
        const reportName = valMatch[1].trim();
        const value = valMatch[2].trim();
        parts.push(
          <span key={`chip-${index}`} className="report-pill-single">
            <span>{reportName}</span>
            <span className="report-score">{value}</span>
          </span>,
        );
      } else {
        parts.push(
          <span
            key={`chip-${index}`}
            className="common-feedback-inline-chip common-feedback-report"
          >
            {cleaned}
          </span>,
        );
      }
    } else if (match.type === "attention") {
      const cleaned = match.text
        .replace(/^!\s*/, "")
        .replace(/^[⚠☆★]\s*/, "")
        .trim();
      parts.push(
        <span key={`chip-${index}`} className="feedback-pill attention-pill">
          <span className="v2-dashboard-feedback-pill-icon">⚠</span>
          <span className="v2-dashboard-feedback-pill-text">{cleaned}</span>
        </span>,
      );
    } else if (match.type === "kudos") {
      const cleaned = match.text
        .replace(/^!\s*/, "")
        .replace(/^[⚠☆★]\s*/, "")
        .trim();
      parts.push(
        <span key={`chip-${index}`} className="feedback-pill kudos-pill">
          <span className="v2-dashboard-feedback-pill-icon">☆</span>
          <span className="v2-dashboard-feedback-pill-text">{cleaned}</span>
        </span>,
      );
    } else if (match.type === "resource") {
      let cleaned = match.text.replace(/^\/\s*/, "").trim();
      if (!cleaned.toLowerCase().startsWith("video:")) {
        cleaned = "Video: " + cleaned;
      }
      parts.push(
        // <span key={`chip-${index}`} className="feedback-pill resource-pill">
        //   <span className="v2-dashboard-feedback-pill-text">{cleaned}</span>
        // </span>,
        <span
          key={`chip-${index}`}
          className="feedback-pill resource-pill"
          onClick={() => feedbackData && onResourceClick?.(feedbackData)}
          style={{
            cursor: feedbackData?.video_id ? "pointer" : "default",
          }}
        >
          <span className="v2-dashboard-feedback-pill-text">{cleaned}</span>
        </span>,
      );
    } else if (match.type === "event") {
      const cleaned = match.text.replace(/^#\s*/, "").trim();
      parts.push(
        <span key={`chip-${index}`} className="feedback-pill event-pill">
          <span className="v2-dashboard-feedback-pill-text">{cleaned}</span>
        </span>,
      );
    } else {
      parts.push(
        <span
          key={`chip-${index}`}
          className={`common-feedback-inline-chip ${match.className}`}
        >
          {match.text}
        </span>,
      );
    }

    lastIndex = match.end;
  });

  // Add remaining text
  if (lastIndex < combinedMessage.length) {
    parts.push(
      <span key={`text-end`}>{combinedMessage.substring(lastIndex)}</span>,
    );
  }

  // If no matches found, just return the message as text
  if (matches.length === 0) {
    return (
      <div className="common-feedback-message-line">
        {combinedMessage || "\u00A0"}
      </div>
    );
  }

  return <div className="common-feedback-message-line">{parts}</div>;
};
